<template>
  <div class="member">
    <div class="member-league pointer" @click="$emit('nameClick')">
      {{ leagueName }}
    </div>
    <div v-for="(member, mIndex) in members" :key="mIndex" class="member-line">
      <el-tag class="member-tag" size="small" :type="mIndex ? '' : 'danger'">{{
        roleMap[member.applyDuties]
      }}</el-tag>
      <span>{{ member.memberName }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    leagueName: {
      type: String,
      default: "",
    },
    members: {
      type: Array,
      default: () => [],
    },
    roleMap: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.member {
  min-height: 100px;
  padding: 15px;
  margin-bottom: 15px;
  &-tag {
    width: 70px;
    text-align: center;
    margin-right: 5px;
    color: #fff;
    background: $theme-color;
    border: none;
    &.el-tag--danger {
      background: #ff484c;
    }
  }
  &-league {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
  }
  &-line {
    margin-bottom: 10px;
  }
}
</style>
